import { soundClipsEn } from './en'

export const soundClipsEnUs = {
  ...soundClipsEn,
} as const
